<template>
    <div class="article-home-what">
        <p>
            I could write pages in answer to this but in short, it is a positively addictive partner dance. It
            originated from Lindy Hop in 1930s and has since evolved into its own unique style allowing dancers to
            incorporate movement from other dance styles such as hip hop, ballet, salsa and contemporary, to name a few.
        </p>
        <p>
            Danced to various genres of music such as blues, R&B, hip-hop, contemporary, pop etc, it is danced primarily
            in a slot with a focus on lead-follow technique and improvised musicality. It has become popular due to its
            versatility in style and music as well as its freedom of movement after learning the basic footwork and
            patterns.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleHomeWhat',
};
</script>
